export function useDownloadLocalFile(response) {

    const link = document.createElement('a');

    link.href = window.URL.createObjectURL(new Blob([response.data]));

    let getPartialFilename = response.headers['content-disposition'].split("filename=");
    let fileName = getPartialFilename[1].split(";")[0];

    link.setAttribute('download', fileName);

    document.body.appendChild(link);

    link.click();
}
